export default "__VITE_ASSET__BB10HX1___"